import {type SuggestValue, Grid, List, Suggest as BaseSuggest} from '@yandex-delivery/blocks'
import {Controller, useFormContext} from 'react-hook-form'

import {toUserAddressPin} from '../../../../api/address/services/addressService/mappers'
import {useService} from '../../../../api/address/suggest'
import {useSuggest} from '../../hooks/useSuggest'
import type {Props} from './types'

export function Suggest({name, isSource, coordinates}: Props) {
  const {control} = useFormContext()
  const {fetchAddressSuggest} = useService()
  const {suggestMode, addressSuggestPlaceholder} = useSuggest()

  return (
    <Controller
      control={control}
      name={name}
      render={({field}) => (
        <BaseSuggest
          key={suggestMode}
          currentMode={suggestMode}
          fetchSuggest={fetchAddressSuggest}
          location={coordinates as [number, number]}
          name={field.name}
          onChange={suggestValue => {
            if (suggestValue) {
              const pointAddress = toUserAddressPin(suggestValue)
              field.onChange(pointAddress)
            }
          }}
          placeholder={addressSuggestPlaceholder}
          pointType={isSource ? 'a' : 'b'}
          portal={false}
          renderItem={renderItem}
        />
      )}
    />
  )
}

function renderItem(point: SuggestValue) {
  return (
    <Grid alignItems="center" justify="space-between" container>
      <Grid item>
        <Grid size="s" container>
          <Grid item xs>
            <List.Label variant="body2">{point.title}</List.Label>
            <List.Description color="minor" variant="caption1">
              {point.subtitle}
            </List.Description>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <List.Description color="minor" variant="caption1">
          {point.distance}
        </List.Description>
      </Grid>
    </Grid>
  )
}
